import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { BoardStatus, setStatus, boardState } from 'common/modules/app/board';
import { Button } from 'common/components';

import { AppState } from 'pages';

interface OwnProps {
  /** ポップアップと同時に表示するか否か */
  withBoard?: boolean;
  /** テスト用識別子 */
  'data-test': string;
}

// StoreのStateからComponentに渡すPropsへ
const useStateProps = (withBoard?: boolean) => {
  const boardState = useSelector<AppState, boardState>(
    (state) => state.app.board
  );
  return {
    isDisplay: withBoard ? boardState.status === BoardStatus.USER_DISP : true
  };
};

// Actionをdispatchする関数からComponentに渡すPropsへ
const useDispatchProps = (withBoard?: boolean) => {
  const dispatch = useDispatch();

  /** アイコンクリック処理 */
  const onClickUser = () => {
    if (withBoard) {
      // UserBoardを非表示
      dispatch(setStatus(BoardStatus.NOT_DISP));
    } else {
      // UserBoardを表示
      dispatch(setStatus(BoardStatus.USER_DISP));
    }
  };

  return {
    onClick: onClickUser
  };
};

/**
 * ユーザーメニューのContainer Component
 */
export default function ContainerComponent(
  ownProps: OwnProps & React.ComponentProps<'div'>
) {
  const _props = {
    ...useDispatchProps(ownProps.withBoard),
    ...useStateProps(ownProps.withBoard)
  };
  return _props.isDisplay ? (
    <Button
      type="toolButton"
      subType="user"
      data-test={ownProps['data-test']}
      {..._props}
    >
      {ownProps.children}
    </Button>
  ) : null;
}
